<template>
    <div class="container">
        <div class="abox">
            <img :src="imgServer+'/family_kefudan.png'" class="img">
            <div class="logo">在线客服</div>
        </div>
    </div>
</template>
<script>
import config from "@/config/index"
export default {
    name: "family",
    data() {
        return {
            imgServer: config.imgServer,
        }
    },
    methods: {}
};
</script>

<style lang="less" scoped>
    @import '../css/common.less';
    .container {
        width: 100%;
        height: 100%;
        background: url('@{img_server}/family_bg.png') center center;
        background-repeat:no-repeat;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }
    .abox {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-top: 100px;
        position: relative;
        .img {
            width: 90%;
            height: auto;
            position: absolute;
            left: 5%;
            top: 0;
        }
        .logo {
            width: 100%;
            height: 76px;
            position: absolute;
            font-size: 28px;
            color: #FFF;
            text-align: center;
            top: -70px;
            font-weight: bold;
        }
        .txtBox {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            .title {
                width: 100%;
                text-align: center;
                font-size: 16px;
                color: #FFF;
                margin-top: 48px;
            }
            .txt1{
                width: 100%;
                height: 20px;
                line-height: 20px;
                color: #A9A9A9;
                font-size: 12px;
                text-align: center;
            }
        }
    }
</style>